"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEAufbauId = exports.AEBefestigungsvariante = exports.AEApplication = exports.GliedAnzahlAbhaengigkeit = exports.AEEinbauart = exports.AEAusrichtung = void 0;
var AEAusrichtung;
(function (AEAusrichtung) {
    AEAusrichtung["pendelnd"] = "pendelnd";
    AEAusrichtung["starr"] = "starr";
})(AEAusrichtung = exports.AEAusrichtung || (exports.AEAusrichtung = {}));
var AEEinbauart;
(function (AEEinbauart) {
    AEEinbauart["freitragend"] = "F";
    AEEinbauart["gleitend"] = "G";
    AEEinbauart["haengend"] = "H";
    AEEinbauart["stehend"] = "S";
})(AEEinbauart = exports.AEEinbauart || (exports.AEEinbauart = {}));
var GliedAnzahlAbhaengigkeit;
(function (GliedAnzahlAbhaengigkeit) {
    GliedAnzahlAbhaengigkeit[GliedAnzahlAbhaengigkeit["keine"] = 0] = "keine";
    GliedAnzahlAbhaengigkeit[GliedAnzahlAbhaengigkeit["ungerade"] = 1] = "ungerade";
    GliedAnzahlAbhaengigkeit[GliedAnzahlAbhaengigkeit["gerade"] = 2] = "gerade";
})(GliedAnzahlAbhaengigkeit = exports.GliedAnzahlAbhaengigkeit || (exports.GliedAnzahlAbhaengigkeit = {}));
var AEApplication;
(function (AEApplication) {
    AEApplication[AEApplication["satz"] = 0] = "satz";
    AEApplication[AEApplication["mitnehmer"] = 1] = "mitnehmer";
    AEApplication[AEApplication["festpunkt"] = 2] = "festpunkt";
})(AEApplication = exports.AEApplication || (exports.AEApplication = {}));
var AEBefestigungsvariante;
(function (AEBefestigungsvariante) {
    AEBefestigungsvariante["A"] = "A";
    AEBefestigungsvariante["A1"] = "A1";
    AEBefestigungsvariante["A2"] = "A2";
    AEBefestigungsvariante["A3"] = "A3";
    AEBefestigungsvariante["A4"] = "A4";
    AEBefestigungsvariante["C2"] = "C2";
})(AEBefestigungsvariante = exports.AEBefestigungsvariante || (exports.AEBefestigungsvariante = {}));
/**
 * Gives information about how the AE is used or which single AE it consists of.
 */
var AEAufbauId;
(function (AEAufbauId) {
    /** (first) single AE */
    AEAufbauId[AEAufbauId["singleFirst"] = 1] = "singleFirst";
    /** (second) single AE */
    AEAufbauId[AEAufbauId["singleSecond"] = 2] = "singleSecond";
    /** one ae pair consisting of two __identical__ single AEs */
    AEAufbauId[AEAufbauId["pairIdentical"] = 11] = "pairIdentical";
    /** one ae pair consisting of two __different__ single AEs */
    AEAufbauId[AEAufbauId["pairDifferent"] = 12] = "pairDifferent";
})(AEAufbauId = exports.AEAufbauId || (exports.AEAufbauId = {}));
//# sourceMappingURL=AEModel.js.map